import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';

/**
 * Ячейка типа 'color'
 */
@Component({
    selector: 'app-color-cell',
    template: `
        <div style="display: flex; align-items: center; margin-top: 5px ">
            <div class="color-container" [ngStyle]="{ 'background-color': '#' + getHex() }"></div>
            {{ getRawValue() }}
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorCellComponent extends BaseCellComponent {
    getHex() {
        return this.getRawValue().replace('#', '');
    }
}
